module.exports = __webpack_public_path__ + "static/media/llama.66e0f28e.svg";